var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"observerElement",staticClass:"intersector",class:_vm.clsx(( _obj = {
    'intersector--active': _vm.isIntersecting,
    'intersector--disabled': !_vm.animationEnabled
  }, _obj[_vm.activeClass] = _vm.isIntersecting, _obj[_vm.onceClass] = _vm.hasBeenIntersected, _obj )),on:{"animationend":_vm.handleAnimationEnd}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }